import React from 'react';
import { DarkModeProvider } from './src/contexts/DarkModeContext';

export const wrapRootElement = ({ element }) => {
  return (
    <DarkModeProvider>
      {element}
    </DarkModeProvider>
  );
};
